// extracted by mini-css-extract-plugin
export default {"message":"AntMessageConfig_message__8+wDq"};